import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReceiptView } from "@/components/ReceiptView";
import { PLAN_FEATURES } from "@/components/UpgradeDialog";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { PLAN_NAMES, formatDate, formatMoney } from "@/lib/constants";

export default function PlansPage() {
  const { user, settings, openUpgrade, refreshMe, upgrade } = useAuth();
  const [receipts, setReceipts] = useState([]);
  useEffect(() => {
    if (!upgrade) { api.get("/billing/receipts/mine").then((r) => setReceipts(r.data)).catch(() => {}); refreshMe(); }
  }, [upgrade, refreshMe]);
  const staff = user.role !== "user";

  return (
    <div>
      <h1 className="font-display text-3xl sm:text-5xl font-extrabold text-[#0b2e20] rise">Тарифы</h1>
      <section className="mt-6 rounded-3xl bg-[#0b2e20] text-white p-6 sm:p-10 grain">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#a3e6be]">Ваш тариф</p>
        <div className="font-display text-4xl font-extrabold mt-2 flex items-center gap-3" data-testid="current-plan"><Crown className="h-8 w-8 text-amber-400" />{PLAN_NAMES[user.plan]}</div>
        <p className="text-white/70 text-sm mt-2" data-testid="current-plan-until">
          {staff ? "У администрации все функции открыты" : user.plan_until ? `Действует до ${formatDate(user.plan_until)}` : "Бесплатный доступ"}
        </p>
        {!staff && <Button onClick={() => openUpgrade()} className="mt-5 rounded-full bg-amber-400 text-[#0b2e20] hover:bg-amber-300 font-bold" data-testid="plans-buy-button">{user.plan === "free" ? "Купить Basic или Pro" : "Продлить или сменить"}</Button>}
      </section>
      {settings && (
        <div className="mt-6 grid sm:grid-cols-2 gap-3">
          {["basic", "pro"].map((p) => (
            <div key={p} className="rounded-2xl bg-white border border-[#d1e7dd] p-5">
              <div className="font-display font-bold text-lg">{PLAN_NAMES[p]} · {formatMoney(settings[`price_${p}`], settings.currency)}</div>
              <ul className="text-sm text-[#4b6b5c] mt-2 space-y-1">{PLAN_FEATURES[p].map((f) => <li key={f}>• {f}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      <h2 className="font-display text-2xl font-bold text-[#0b2e20] mt-10">Мои чеки</h2>
      <div className="mt-4 grid md:grid-cols-2 gap-4" data-testid="my-receipts-list">
        {receipts.length === 0 && <p className="text-sm text-[#6b8a7b]" data-testid="my-receipts-empty">Покупок пока нет</p>}
        {receipts.map((r) => <ReceiptView key={r.id} r={r} printable={false} />)}
      </div>
    </div>
  );
}
